import React, { useEffect, useState } from "react";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { SxProps, TextField } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorTextInterface {
    editObject: object;
    label?: string;
    propertyName: string;
    hint?: string;
    requiredText?: string;
    parentDefaultValue?: string | null;
    autoFocus?: boolean;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export function PropertyEditorText(props: PropertyEditorTextInterface) {
    let [val, setVal] = useState<string>(Reflect.get(props.editObject, props.propertyName) ?? props.parentDefaultValue);

    useEffect(() => {
        setVal(Reflect.get(props.editObject, props.propertyName) ?? props.parentDefaultValue);
    }, [props.editObject, props.parentDefaultValue]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setVal(event.target.value);
    };

    const onBlur = () => {
        if (props.parentDefaultValue && val === props.parentDefaultValue) {
            Reflect.set(props.editObject, props.propertyName, undefined);
        } else {
            Reflect.set(props.editObject, props.propertyName, val);
        }

        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );
                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <TextField
                            data-testid={`property-${props.propertyName}-text`}
                            error={Boolean(validationIssues)}
                            value={val || ""}
                            label={props.label}
                            onChange={onChange}
                            onBlur={onBlur}
                            variant="outlined"
                            size={"small"}
                            fullWidth={true}
                            autoFocus={props.autoFocus}
                            helperText={validationIssues?.message ?? props.hint}
                            sx={props.sx}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
}
